// extracted by mini-css-extract-plugin
module.exports = {"animationContainer":"Section-module--animation-container--T1_L-","contentContainer":"Section-module--content-container--3cU3-"};